// extracted by mini-css-extract-plugin
export default {"RouteHighlighter":"b5xyy"};